import styled from 'styled-components'
import { fonts } from '../../../styles/GlobalVariables'

interface StyledInputProps {
  paddingTop?: number
}
export const SearchContainer = styled.div<StyledInputProps>`
  width: 100%;
  padding-top: 3.4vw;
  padding-left: 5.7vw;
  padding-right: 5.7vw;

  div {
    label {
      position: relative;
      width: 100%;
      height: 0.03vw;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      margin-bottom: 6.39vw;
      background: linear-gradient(
        90deg,
        #06060d 0%,
        #0c0f1f 50.1%,
        #06060d 100%
      );
    }

    input {
      width: 100%;
      padding: 0.3vw 0 1.55vw 0;
      font-family: ${fonts.narkis};
      font-size: 1.8vw;
      line-height: 1.8vw;
      letter-spacing: -0.06vw;
      color: #dfdfdf;
      background: transparent;
      border: none;
      border-bottom: 0.1vw solid #dfdfdf;
      text-align: right;
      outline: none;
      -webkit-appearance: none;
      border-radius: 0;

      &:focus {
        border-bottom: 0.1vw solid #dfdfdf;

        &::placeholder {
          opacity: 0;
        }
      }

      &::placeholder {
        position: relative;
        top: 0;
        right: 0;
        color: #dfdfdf;
        font-size: 1.88vw;
        text-align: right;
        font-family: 'Narkiss Block RESHET', sans-serif;
        transition: opacity 0.3s ease;
      }
    }

    span {
      position: absolute;
      margin-top: 1.2vw;
      left: 0;
      transform: translateY(-50%);
      cursor: pointer;
      color: #dfdfdf;
      font-size: 1.7vw;
      font-weight: bold;
    }
  }

  @media only screen and (max-width: 768px) {
    padding-top: 15.4vw;
    padding-bottom: 4.5vw;
    div {
      label {
        margin-right: 0;
        width: 100%;
        display: flex;
        margin-bottom: 10.7vw;
        align-items: center;
        justify-content: center;
      }

      input {
        flex-shrink: 0;
        padding: ${props => props.paddingTop}vw 0 4.9vw 5.7vw;
        font-size: 27px;

        &::placeholder {
          font-size: 6.8vw;
        }
      }

      span {
        font-size: 5vw;
        margin-top: 13vw;
        transform: translateY(-128%);
      }
    }
  }
`
export const EmptyDataContainer = styled.div`
  color: #fff;
  text-align: center;
  font-family: 'Narkiss Block RESHET', sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.5px;
  margin-top: 2.2vw;
  margin-bottom: 1.9vw;

  @media only screen and (max-width: 768px) {
    margin-top: 5vw;
    margin-bottom: 6vw;
  }
`
